/**
 * MafiaRoleReveal — Role reveal screen with acknowledge button
 *
 * Requirements: 3.4, 3.5, 3.6, 21.3
 */

import React from 'react';
import { MafiaRole, Team, ROLE_INFO } from '../types';
import './MafiaRoleReveal.css';

export interface MafiaRoleRevealProps {
  role: MafiaRole;
  team: Team;
  mafiaMembers?: string[];
  onAcknowledge: () => void;
}

export const MafiaRoleReveal: React.FC<MafiaRoleRevealProps> = ({
  role,
  team,
  mafiaMembers,
  onAcknowledge,
}) => {
  const roleInfo = ROLE_INFO[role];

  return (
    <div className="mafia-role-reveal" role="alert" aria-live="assertive" aria-label="Role Assignment">
      <div className="mafia-role-reveal__icon">{roleInfo.icon}</div>

      <h2 className="mafia-role-reveal__role-name">{roleInfo.name}</h2>

      <div className={`mafia-role-reveal__team mafia-role-reveal__team--${team}`}>
        Team {team === 'village' ? 'Village' : 'Mafia'}
      </div>

      <p className="mafia-role-reveal__description">{roleInfo.description}</p>

      {role === 'mafia' && mafiaMembers && mafiaMembers.length > 0 && (
        <div className="mafia-role-reveal__mafia-members">
          <h3>🔪 Your Fellow Mafia Members</h3>
          <ul className="mafia-role-reveal__mafia-list">
            {mafiaMembers.map((name, i) => (
              <li key={i}>{name}</li>
            ))}
          </ul>
        </div>
      )}

      <button
        className="mafia-role-reveal__acknowledge"
        onClick={onAcknowledge}
        aria-label="Acknowledge role and continue"
      >
        I Understand — Continue
      </button>
    </div>
  );
};

export default MafiaRoleReveal;
